/**
 * 서류 공유 / 요청 시트 (일지 카드 > 내 서류 보내기 · 상대 서류 요청)
 *
 * 구 Diary/Main.js 의 전역 _renderDocSharePopup() 이관.
 * 구 창은 body 에 직접 붙이는 z-index:999999999 인라인 DOM 이었고, 체크박스 3개가
 * **각각 독립인 것처럼** 보였다 — 실제로는 누적(1⊂2⊂3)이라 '장비문서'만 켜면 기본문서가
 * 슬그머니 같이 켜졌다. 고른 것과 실제로 나가는 것이 달랐다.
 *
 * 그래서 서류등록 화면(/m/docs/v1 '서류 자동 제출')과 **같은 어휘**로 맞춘다 —
 * 범위를 누적으로 적어 한 줄만 읽어도 무엇이 나가는지 알 수 있게 한다.
 *   기본서류만 / 기본 + 장비서류 / 기본 + 장비 + 기사서류
 *
 * [호출]
 *   $j.F.Diary.DocShareSheet.open({ sendType, ordernum, othernum, defCnt, carCnt, manCnt, autoCall, autoSetNum })
 *
 * 저장은 Diary/Main.js 의 전역 sendDocShareLevel(o, lv) 이 맡는다 —
 * 서버 규약(doc-share/level · doc-share/request)은 건드리지 않았다.
 */
import Util from '../../Common/Util';
export default class DocShareSheet {

    /** 범위 3단계 — 누적이다. 값이 곧 서버의 level(1~3). */
    static LEVELS = [
        { v: 1, send: '기본서류만',              req: '기본서류만',              desc: '사업자등록증 · 통장사본' },
        { v: 2, send: '기본 + 장비서류',         req: '기본 + 장비서류',         desc: '위 서류 + 장비 관련 서류 전부' },
        { v: 3, send: '기본 + 장비 + 기사서류',  req: '기본 + 장비 + 기사서류',  desc: '위 서류 + 기사 관련 서류 전부' },
    ];

    open(opts) {
        this.opts = opts || {};
        $j.Ui.BS.open({ target: this, data: this.opts });
    }

    init() {
        const o = this.data || this.opts || {};
        const isReq = o.sendType === 'request';

        $j.Ui.BS.setTitle(isReq ? '수주자 서류 요청' : '내 서류 보내기');
        $(`#${this.id}`).html(this.html(o, isReq));
        this.bind(o);
    }

    /**
     * 지금 켜져 있는 범위. 구 창은 체크 개수로 셌지만, 켜진 것 중 **가장 높은 단계**가 곧 범위다.
     * 아무것도 없으면 0 — '보내지 않음'.
     */
    currentLevel(o) {
        if (Number(o.manCnt) > 0) return 3;
        if (Number(o.carCnt) > 0) return 2;
        if (Number(o.defCnt) > 0) return 1;
        return 0;
    }

    html(o, isReq) {
        const cur = this.currentLevel(o);
        const rows = DocShareSheet.LEVELS.map(L => this.rowHtml(L, cur, isReq)).join('');

        return `
        <div class="dshare">
            ${this.askedHtml(o)}
            <section class="jb-card dshare__card">
                <h2 class="jb-card-hd">
                    <i class="fas fa-${isReq ? 'hand-paper' : 'paper-plane'}"></i>${isReq ? '요청할 범위' : '보낼 범위'}
                </h2>
                ${rows}
            </section>
            <div class="dshare__foot">
                <button type="button" class="dshare__btn js-dshare-cancel">취소</button>
                <button type="button" class="dshare__btn dshare__btn--ok js-dshare-ok">
                    ${isReq ? '요청 보내기' : '이 범위로 공개'}
                </button>
            </div>
        </div>`;
    }

    /**
     * 한 줄 = 한 단계. 누적이라 라디오가 맞다 — 체크박스 3개는 '따로 고르는 것'으로 읽힌다.
     * (구 창이 정확히 그 오해를 만들었다)
     */
    rowHtml(L, cur, isReq) {
        const on = cur === L.v;
        return `
        <label class="dshare__li${on ? ' is-on' : ''}">
            <input type="radio" name="dshareLevel" value="${L.v}" ${on ? 'checked' : ''}>
            <span class="dshare__li-txt">
                <span class="dshare__li-tit">${isReq ? L.req : L.send}</span>
                <span class="dshare__li-desc">${L.desc}</span>
            </span>
        </label>`;
    }

    /** 상대가 먼저 요청해서 들어온 자리면, 무엇을 요청받았는지 먼저 보여준다. */
    askedHtml(o) {
        const n = Number(o.autoSetNum) || 0;
        if (n < 1) return '';
        const asked = (o.autoCall === 'baljoo')
            ? '기본서류만'
            : (DocShareSheet.LEVELS.find(L => L.v === n) || {}).send;
        if (!asked) return '';
        return `
        <div class="dshare__asked">
            <i class="fas fa-circle-info"></i>
            <span>상대가 <b>${asked}</b>를 요청했습니다.</span>
        </div>`;
    }

    bind(o) {
        const $el = $(`#${this.id}`);

        $el.on('change', 'input[name="dshareLevel"]', function () {
            $el.find('.dshare__li').removeClass('is-on');
            $(this).closest('.dshare__li').addClass('is-on');
        });

        $el.on('click', '.js-dshare-cancel', () => $j.Ui.BS.close());

        $el.on('click', '.js-dshare-ok', () => {
            const lv = parseInt($el.find('input[name="dshareLevel"]:checked').val(), 10) || 0;
            if (lv < 1) { Util.swalert('보낼 범위를 고르세요.'); return; }
            if (lv === this.currentLevel(o)) { Util.swalert('변경사항이 없습니다.'); return; }
            $j.Ui.BS.close();
            window.sendDocShareLevel(o, lv);
        });
    }
}
